import HowWeDiffer from './how-we-differ';

export default HowWeDiffer;
